import React, { useEffect, useMemo, useState } from 'react'
import Avatar from '@mui/material/Avatar'
import CardMedia from '@mui/material/CardMedia'
import { SxProps } from '@mui/material'

const placeholderIcon: string = require('components/EntityCard/images/placeholder.svg')

interface VerticalCardAvatarProps {
  profileImage: string
  sx: SxProps
}

const VerticalCardAvatar = ({ profileImage, sx }: VerticalCardAvatarProps) => {
  const [imageError, setImageError] = useState(false)

  useEffect(() => {
    setImageError(false)
  }, [profileImage])

  const renderAvatarContent = useMemo(() => {
    if (profileImage && !imageError) {
      return <CardMedia component='img' image={profileImage} alt='Avatar' onError={() => setImageError(true)} />
    }
    
    return <img src={placeholderIcon} alt='Avatar' style={{ width: '100%', height: '100%' }} />
  }, [profileImage, imageError])

  return (
    <Avatar sx={sx}>
      {renderAvatarContent}
    </Avatar>
  )
}

export default VerticalCardAvatar
